import React from 'react';
import { Grid, Typography } from '@mui/material';
import './CallAnalysisBenefits.css';
import leadsIcon from "../../assests/Pages/CallAnalysis/person_logo_ca_benefits.png"
import callsIcon from "../../assests/Pages/CallAnalysis/phonecall_logo_ca_benefits.png"
import timeIcon from "../../assests/Pages/CallAnalysis/time_logo_ca_benefits.png" 

const benefitsData = [
  { percentage: '10%', text: 'Increase in Leads from improved marketing',icon: leadsIcon  },
  { percentage: '50%', text: 'Less time spent reviewing and analyzing calls', icon: callsIcon },
  { percentage: '60%', text: 'Less time spent qualifying leads' , icon: timeIcon},
];

const CallAnalysisBenefits = () => {
  return (
    <Grid container className="ca-benefits-main-container" justifyContent="center" height="auto">
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Grid container gap={8} direction="column" alignItems="center">

          <Grid item xs={6}>
            <Typography className="ca-benefits-title">
              Benefits of Conversational AI in Call Analysis
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid container className="short-gap"  flexWrap={{ md : "nowrap", xs: "wrap" }} justifyContent="center" height={"auto"}>
              {benefitsData.map((item, index) => (
                <Grid item xs={12} sm={6} md={6} lg={3} key={index} className="ca-benefit-box">
                  <div className="ca-benefit-content">
                    <div>
                      <span className="ca-benefit-percent">{item.percentage}</span>
                      <Typography className="ca-benefit-text">{item.text}</Typography>
                    </div>
                  </div>
                  <img src={item.icon} alt="Icon" className="ca-benefit-icon" />

                </Grid>

              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CallAnalysisBenefits;
